<template>
  <el-form ref="ff" label-width="100px" label-position="top" :model="detail">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="选择用户" prop="Name" required class="flexItem">
          <el-autocomplete :fetch-suggestions="userSearch" @select="userChange" :debounce="500" value-key="Name" v-model="detail.Name" style="width: 100%; margin-right: 10px">
            <i @click="userChange({})" class="el-icon-circle-close" slot="suffix" style="margin-right: 10px" />
          </el-autocomplete>
          <el-input v-model="detail.Account" disabled />
          <el-input v-model="detail.Phone" disabled />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所属部门" required>
          <el-cascader
            v-model="detail.DeptId"
            :options="deptOptions"
            :props="{
              value: 'Id',
              label: 'Name',
              emitPath: false,
              checkStrictly: true,
            }"
            clearable
            style="width: 100%"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="项目询价访问控制" class="flexItem">
          <el-checkbox
            true-label="ALL"
            false-label=""
            @change="
              (val) => {
                detail.Project_Inquiry = val
              }
            "
            :checked="detail.Project_Inquiry == 'ALL'"
            style="margin-right: 10px"
            >查看全部
          </el-checkbox>
          <el-cascader
            v-if="detail.Project_Inquiry != 'ALL'"
            v-model="detail.Project_Inquiry"
            :options="deptOptions"
            :props="{
              value: 'Id',
              label: 'Name',
              multiple: true,
              emitPath: false,
              checkStrictly: true,
              expandTrigger: 'hover',
            }"
            collapse-tags
            clearable
            :show-all-levels="false"
            placeholder="指定部门（多选）"
            style="width: 100%"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="订购申请访问控制" class="flexItem">
          <el-checkbox
            true-label="ALL"
            false-label=""
            @change="
              (val) => {
                detail.Product_Purchase = val
              }
            "
            :checked="detail.Product_Purchase == 'ALL'"
            style="margin-right: 10px"
            >查看全部
          </el-checkbox>
          <el-cascader
            v-if="detail.Product_Purchase != 'ALL'"
            v-model="detail.Product_Purchase"
            :options="deptOptions"
            :props="{
              value: 'Id',
              label: 'Name',
              multiple: true,
              emitPath: false,
              checkStrictly: true,
              expandTrigger: 'hover',
            }"
            collapse-tags
            clearable
            :show-all-levels="false"
            placeholder="指定部门（多选）"
            style="width: 100%"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="销售申请访问控制" class="flexItem">
          <el-checkbox
            true-label="ALL"
            false-label=""
            @change="
              (val) => {
                detail.Product_Presale = val
              }
            "
            :checked="detail.Product_Presale == 'ALL'"
            style="margin-right: 10px"
            >查看全部
          </el-checkbox>
          <el-cascader
            v-if="detail.Product_Presale != 'ALL'"
            v-model="detail.Product_Presale"
            :options="deptOptions"
            :props="{
              value: 'Id',
              label: 'Name',
              multiple: true,
              emitPath: false,
              checkStrictly: true,
              expandTrigger: 'hover',
            }"
            collapse-tags
            clearable
            :show-all-levels="false"
            placeholder="指定部门（多选）"
            style="width: 100%"
          />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item>
          <el-checkbox v-model="detail.Product_Stock">允许查看库存数量</el-checkbox>
          <el-checkbox v-model="detail.Product_Material">允许查看耗材价格</el-checkbox>
          <el-checkbox v-model="detail.Project_Enroll">允许查看全部报备信息</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item label="出库单访问控制" class="flexItem">
          <el-input v-model="detail.Product_Outbound_Depts" placeholder="部门集" />
          <el-input v-model="detail.Product_Outbound_Sales" placeholder="业务员" />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item label="政采数据分析授权" class="flexItem">
          <itemPicker typeId="region" style="flex: 1">
            <template slot-scope="{ data }">
              <el-cascader
                placeholder="授权地区"
                v-model="detail.Trend_Region"
                :options="data"
                :props="{
                  value: 'Name',
                  label: 'Name',
                  emitPath: false,
                  multiple: true,
                }"
                collapse-tags
                clearable
                style="width: 100%"
              />
            </template>
          </itemPicker>
          <itemPicker style="flex: 1; margin-left: 10px" typeId="category">
            <template slot-scope="{ data }">
              <el-cascader
                placeholder="授权品类"
                v-model="detail.Trend_Category"
                :options="data"
                :props="{
                  value: 'Name',
                  label: 'Name',
                  emitPath: false,
                  multiple: true,
                }"
                collapse-tags
                clearable
                style="width: 100%"
              />
            </template>
          </itemPicker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button type="primary" @click="onSubmit" v-loading.fullscreen.lock="loading">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {
    itemPicker: () => import("@/views/system/meta/item/picker.vue")
  },
  data () {
    return {
      loading: false,
      deptOptions: [],
      detail: { ...this._detail }
    }
  },
  props: {
    _detail: { type: Object, default: null },
    layerid: { type: String, default: null }
  },
  created () {
    {
      //字符串转为数组
      this.detail.Project_Inquiry = this.detail.Project_Inquiry?.split(',')
      this.detail.Product_Purchase = this.detail.Product_Purchase?.split(',')
      this.detail.Product_Presale = this.detail.Product_Presale?.split(',')
      this.detail.Trend_Region = this.detail.Trend_Region?.split(',') || []
      this.detail.Trend_Category = this.detail.Trend_Category?.split(',') || []
    }
    this.$apis.organize.dept.list().then(res => {
      this.deptOptions = res
    })
  },
  methods: {
    userSearch (queryString, cb) {
      this.$apis.system.user.getList({
        size: 10,
        keyWord: queryString
      }).then(res => {
        let options = res.Items.map(row => {
          return {
            value: row.Id,
            Account: row.Account,
            Name: row.Name,
            Phone: row.Phone
          }
        }) || []
        cb(options)
      })
    },
    userChange (item) {
      this.detail = {
        UserId: item.value,
        Account: item.Account,
        Name: item.Name,
        Phone: item.Phone
      }
    },

    //提交数据
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          console.log(this.detail)
          this.loading = true
          {
            //将多部门授权转为字符串提交
            this.detail.Project_Inquiry = this.detail.Project_Inquiry?.toString()
            this.detail.Product_Purchase = this.detail.Product_Purchase?.toString()
            this.detail.Product_Presale = this.detail.Product_Presale?.toString()
            this.detail.Trend_Region = this.detail.Trend_Region?.toString()
            this.detail.Trend_Category = this.detail.Trend_Category?.toString()
          }
          this.$apis.organize.staff.submit(this.detail).then(res => {
            this.$layer.close(this.layerid)
            this.$parent.loadData()
            this.$message({ message: res || "数据提交成功！", type: "success" })
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

